/**
 * @format
 */
'use strict';
/* Controllers for the autoremind.communication feature */
import { JobActions } from '../../../../../ngapp/src/app/job/job.actions';
import { ReasonsSettingsActions } from '../../../../../ngapp/src/app/reasons/state/reasons-settings.actions';
import { PreviewEditTemplateActions } from '../../../../../ngapp/src/app/preview-edit-template/state/preview-edit-template.actions';
import { TrackableItemsActions } from '../../../../../ngapp/src/app/trackable-items/trackable-items.actions';
/**
 * Main screen controller for the communication screen
 */
angular.module('autoremind.communications').controller('autoremind.communications.ScreenController', 
// Setup dependencies
[
    '$scope',
    '$log',
    '$location',
    'dialogs',
    'userProfile',
    'jobService',
    '$timeout',
    'accountService',
    'templateService',
    '$filter',
    'storeDowngraded',
    'reasonsSettingsSelectorsDowngraded',
    'trackableItemSelectorDowngraded',
    'previewEditSelectorDowngraded',
    'appointmentServiceDowngraded',
    'eventSharingService',
    function ($scope, $log, $location, dialogs, userProfile, jobService, $timeout, accountService, templateService, $filter, storeDowngraded, reasonsSettingsSelectorsDowngraded, trackableItemSelectorDowngraded, previewEditSelectorDowngraded, appointmentServiceDowngraded, eventSharingService) {
        $scope.APPOINTMENT = jobService.APPOINTMENT_TRIGGER;
        $scope.ORDERS = jobService.ORDERS_TRIGGER;
        $log.info('In autoremind.communications.ScreenController');
        $scope.currentUser = accountService.currentUser;
        $scope.selectedUser = undefined;
        $scope.thereCategories = true;
        $scope.isVets = eventSharingService.hasPermission(['resource:pets']);
        $scope.previousUpdatedModelChangeCategory = {};
        $scope.templateFileRef = {};
        $scope.selectedTriggeredMessageType = jobService.APPOINTMENT_TRIGGER;
        $scope.hasOrders = eventSharingService.hasPermission(['communication:trackable:item']);
        // Temporary feature toggles
        $scope.hasTmpAppointmentSince = eventSharingService.hasPermission(['communication:birthday:since:tmp']);
        $scope.hasAR3Latepayment = eventSharingService.hasPermission(['communication:latepayment:ar3:tmp']);
        // Initialize
        userProfile.initalizeViewModel();
        userProfile.getProfileIfNotLoaded(function () {
            // false means only load data from server once
            console.debug('SystemCheckController: got user profile');
            //$scope.systemcheckModel.timezone = userProfile.profileModel.timezone;
            //angularMomentConfig.timezone = userProfile.profileModel.tz;
        });
        userProfile.viewModel.views.communications = {};
        userProfile.viewModel.views.communications.selectedCategory = null;
        $scope.triggerJob = {
            targets: null,
            triggerSetting: null,
            trackableItemCategoryId: null,
        };
        jobService.disableTriggerHoursDropDown = false;
        $scope.init = function () {
            jobService.categories = [];
            var userInfo = angular.copy(accountService.currentUser);
            accountService.getUser($scope.currentUser.userId, undefined, $scope.loadingIndicator).then(function (user) {
                $scope.selectedUser = user;
            });
            accountService
                .getUserCommunications(userInfo, $scope.loadingIndicator, true, true)
                .then(function (userInfo) {
                // TODO: Use retry button if loading fails
                // Though this is working in Dev URL but in local, it was throwing cannot update read only
                var currentUser = angular.copy($scope.currentUser);
                currentUser.communication = userInfo.communication;
                $scope.currentUser = currentUser;
                $scope.getTemplates();
            });
            previewEditSelectorDowngraded.selectTemplateUpdateModel().subscribe(function (templateUpdateModel) {
                const currentUpdatedModel = templateUpdateModel.updatedModel;
                let shouldSaveEnabled = false;
                if (templateUpdateModel.updateType === "changeCategory" &&
                    JSON.stringify($scope.previousUpdatedModelChangeCategory) === JSON.stringify(currentUpdatedModel)) {
                    $scope.previousUpdatedModelChangeCategory = Object.assign({}, currentUpdatedModel);
                }
                else if (templateUpdateModel.updateType === "changeCategory") {
                    $scope.previousUpdatedModelChangeCategory = Object.assign({}, currentUpdatedModel);
                    $scope.templateUpdateModel = angular.copy(templateUpdateModel);
                }
                else {
                    shouldSaveEnabled = jobService.isModelProcessed || templateUpdateModel.isModelUpdated;
                    $scope.templateUpdateModel = angular.copy(templateUpdateModel);
                }
                jobService.job.setEdited(shouldSaveEnabled);
            });
            previewEditSelectorDowngraded.selectIsModelProcessed().subscribe(function (isModelProcessed) {
                jobService.isModelProcessed = angular.copy(isModelProcessed);
            });
            if (accountService.hasUserPermission("resource:pets")) {
                jobService.job.getSpecies();
            }
            storeDowngraded.dispatch(TrackableItemsActions.getItemCategory({ userId: $scope.currentUser.userId }));
            trackableItemSelectorDowngraded.selectItemCategory().subscribe(function (itemCategories) {
                if (itemCategories) {
                    $log.debug("Got reasons from server: ");
                    jobService.itemCategories = angular.copy(itemCategories);
                }
            });
        };
        $scope.init();
        $scope.selectCategory = function (category) {
            jobService.selectCategory(category);
            var templateDefaultContent = {};
            $scope.template = Object.assign(Object.assign({}, jobService.template), { ['templateId']: category.job.jobContent.media[0].templateId });
            Object.entries(jobService.template).forEach(function (tData) {
                var updatedTemplateDefault = jobService.templateContextFormat(tData[1], 'db');
                templateDefaultContent[tData[0]] = updatedTemplateDefault.value;
            });
            jobService.templateUpdateModel = {
                updatedModel: templateDefaultContent,
                isModelUpdated: false,
                updateType: 'changeCategory',
            };
            if (angular.isDefined(jobService.template.templateId) &&
                angular.isDefined($scope.viewModel.selectedTemplate)) {
                $scope.viewModel.selectedTemplate.templateId = jobService.template.templateId;
            }
        };
        $scope.getTemplates = function () {
            jobService.templates.getTemplates().then(function (templates) {
                if (!angular.isDefined($scope.currentUser.communication)) {
                    $scope.thereCategories = false;
                    return;
                }
                //TODO: move this to jobService - nothing view specific here
                jobService.categories = [];
                for (var c = 0; c < jobService.availableCategories.length; ++c) {
                    var category = angular.copy(jobService.availableCategories[c]);
                    for (var usersCategoryIndex = 0; usersCategoryIndex < $scope.currentUser.communication.categories.length; ++usersCategoryIndex) {
                        var usersCategory = angular.copy($scope.currentUser.communication.categories[usersCategoryIndex]);
                        if (category.communicationsCategoryId === usersCategory.communicationsCategoryId) {
                            // It's in user's list of categories, so get the settings from user
                            category.categoryEnabled = usersCategory.categoryEnabled;
                            break;
                        }
                    }
                    var template = null;
                    // TODO: Handle if availableCategories has category not in user's settings
                    // Find matching master template in user's templates, if any
                    for (var i = 0; i < templates.length; ++i) {
                        if (templates[i].communicationsCategoryId !== category.communicationsCategoryId) {
                            continue;
                        }
                        template = templates[i];
                        if (template.isMaster) {
                            break; // NOTE: We use only the first master of the same category
                        }
                    }
                    if (template !== null) {
                        //category.communicationsCategoryName = $filter('i18n')( '_communicationsCategory_' + category.communicationsCategoryId + '_' ) ;//template.templateDisplayName, // TODO: Get from localization database (and thus not from template table)
                        category.automatedJobs = template.automatedJobs;
                        //category.categoryEnabled = template.isEnabled, // NOTE: The icon should be disabled if feature disabled on account?
                        category.job = jobService.createDefaultJob(template);
                        jobService.categories.push(category);
                    }
                    else {
                        category.isNoTemplate = true;
                        jobService.categories.push(category);
                        // TODO: set flag to show UI for disabled category
                        // TODO: consider setting this EVEN if there are templates in the database - and enabled? flag this to support
                        // TODO: push to list
                    }
                }
            }, function () {
                dialogs.error("Server problem", "There was a problem getting the template list from the server.");
            });
        }; // End of getTemplates()
        $scope.updateAutomatedCounts = function () {
            jobService.templates.getTemplates().then(function (templates) {
                for (var c = 0; c < jobService.categories.length; ++c) {
                    var category = jobService.categories[c];
                    for (var i = 0; i < templates.length; ++i) {
                        if (templates[i].communicationsCategoryId === category.communicationsCategoryId &&
                            category.isMaster) {
                            category.automatedJobs = templates[i].automatedJobs;
                            break; // NOTE: We use only the first master of the same category
                        }
                    }
                }
            }, function () {
                dialogs.error("Server problem", "There was a problem getting the template list from the server.");
            });
        }; // End of updateAutomatedCounts()
        // ---------------------------------------------------------
        jobService.hoursOfDay = [
            { label: "06:00 am", hour: 6 },
            { label: "07:00 am", hour: 7 },
            { label: "08:00 am", hour: 8 },
            { label: "09:00 am", hour: 9 },
            { label: "10:00 am", hour: 10 },
            { label: "11:00 am", hour: 11 },
            { label: "12:00 pm", hour: 12 },
            { label: "1:00 pm", hour: 13 },
            { label: "2:00 pm", hour: 14 },
            { label: "3:00 pm", hour: 15 },
            { label: "4:00 pm", hour: 16 },
            { label: "5:00 pm", hour: 17 },
            { label: "6:00 pm", hour: 18 },
            { label: "7:00 pm", hour: 19 },
            { label: "8:00 pm", hour: 20 },
            { label: "9:00 pm", hour: 21 },
        ];
        jobService.daysOfMonth = [
            { label: "1st", day: 1 },
            { label: "2nd", day: 2 },
            { label: "3rd", day: 3 },
            { label: "4th", day: 4 },
            { label: "5th", day: 5 },
            { label: "6th", day: 6 },
            { label: "7th", day: 7 },
            { label: "8th", day: 8 },
            { label: "9th", day: 9 },
            { label: "10th", day: 10 },
            { label: "11th", day: 11 },
            { label: "12th", day: 12 },
            { label: "13th", day: 13 },
            { label: "14th", day: 14 },
            { label: "15th", day: 15 },
            { label: "16th", day: 16 },
            { label: "17th", day: 17 },
            { label: "18th", day: 18 },
            { label: "19th", day: 19 },
            { label: "20th", day: 20 },
            { label: "21st", day: 21 },
            { label: "22nd", day: 22 },
            { label: "23rd", day: 23 },
            { label: "24th", day: 24 },
            { label: "25th", day: 25 },
            { label: "26th", day: 26 },
            { label: "27th", day: 27 },
            { label: "28th", day: 28 },
            { label: "29th", day: 29 },
            { label: "30th", day: 30 },
            { label: "31st", day: 31 },
        ];
        jobService.maxMessagesOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
        // Map shared model to scope for local reference
        $scope.viewModel = userProfile.viewModel.views.communications;
        //Model for 'Send test'
        $scope.viewModel.destinatorSms = "";
        $scope.viewModel.destinatorVoice = "";
        $scope.viewModel.destinatorSmsCountry = "";
        $scope.viewModel.destinatorEmail = "";
        // Map to models in jobService to use directly in view
        $scope.jobService = jobService;
        $scope.jobs = jobService.jobs;
        $scope.job = jobService.job;
        $scope.templates = jobService.templates;
        $scope.templateList = [];
        $scope.template = jobService.template; // This mapping is used in the templates
        $scope.editable = jobService.job.editable; // This mapping is used in the templates
        $scope.templateService = templateService;
        $scope.viewModel.loadingIndicator2 = { state: false, refCount: 0 }; // Currently not used in view
        jobService.selectedCategory = null;
        jobService.isVets = $scope.isVets;
        $scope.viewModel.categoryVisibleList = [];
        $scope.viewModel.smsParts = 1;
        $scope.currentItemCategory = null;
        $scope.setJobEdited = function () {
            jobService.job.setEdited(true);
        };
        $scope.$watch("template", function (newVal, oldVal) {
            //console.log('templateWasChanged', newVal, oldVal);
            if (newVal.templateId === -1) {
                return;
            }
            previewEditSelectorDowngraded.selectGetSmsParts().subscribe(function (smsParts) {
                $scope.viewModel.smsParts = angular.copy(smsParts);
            });
            if ($scope.templateList.length === 0) {
                $scope.templateList = [...jobService.templates.list];
            }
            if (newVal.templateId !== oldVal.templateId) {
                templateService.model.currentTemplate = newVal;
                templateService.previewModel.inDb = newVal;
                // console.table($scope.templateList, ['index', 'templateId','templateFileRef','templateName']);
                for (var i in $scope.templateList) {
                    const template = $scope.templateList[i];
                    if (newVal.templateId === template.templateId) {
                        $scope.viewModel.selectedTemplate = Object.assign({}, template);
                        $scope.templateFileRef = $scope.viewModel.selectedTemplate.templateFileRef;
                        break;
                    }
                }
                return;
            }
            // console.log('templateWasChanged', newVal, oldVal);
        }, true);
        /**
         * Filter that returns the class name suitable for the size of the number.
         * If less than 4 digits then use biggest font, 5 digits then use medium and more digits then use smallest
         */
        $scope.getDigitsClass = function (value) {
            if (value < 1000)
                return "big-numbers";
            if (value < 10000 && value >= 1000)
                return "medium-numbers";
            if (value > 10000)
                return "small-numbers";
        };
        $scope.viewModel.templateParameters = [
            { label: "firstname", name: "person.firstName" },
            { label: "lastname", name: "person.lastName" },
            { label: "company", name: "account.companyName" },
        ];
        $scope.saveJob = function () {
            $scope.updateTemplateModelBeforeSaving();
            if (!$scope.isValidTrackableItemJob()) {
                return;
            }
            if ($scope.isSaveMode($scope.job.data.jobName)) {
                // set JobId as undefined will force to save a new draft
                $scope.job.data.jobId = undefined;
            }
            $timeout(function () {
                $scope.job.save("draft");
            }, 300);
        };
        $scope.updateTemplateModelBeforeSaving = function () {
            var modelAfterAutoCorrect = eventSharingService.validateTemplateBeforeSave($scope.templateUpdateModel.updatedModel);
            var cloneTemplateUpdateModel = {
                updatedModel: modelAfterAutoCorrect,
                isModelUpdated: false,
                updateType: 'savedJob'
            };
            jobService.templateUpdateModel = cloneTemplateUpdateModel;
            if ($scope.templateUpdateModel.updatedModel.voiceMessage !== undefined && $scope.templateUpdateModel.updatedModel.voiceMessage === 'Insert Text Here') {
                $scope.templateUpdateModel.updatedModel.voiceMessage = '';
            }
            jobService.template = angular.copy($scope.templateUpdateModel.updatedModel);
        };
        $scope.isSaveMode = function (currentName) {
            return jobService.jobPreviousName !== currentName;
        };
        $scope.updateTemplateModel = function (variable, value) {
            storeDowngraded.dispatch(PreviewEditTemplateActions.templateUpdateModelVariable({
                value: value,
                variableName: variable,
                reloadPreview: false,
            }));
        };
        $scope.refreshTemplateValues = function () {
            $scope.template = jobService.template;
        };
        /**
         * Open/close the date picker
         */
        $scope.toggleDatepicker = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.viewModel.datepickerOpened = !$scope.viewModel.datepickerOpened;
        };
        $scope.toggleDatepicker2 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.viewModel.datepicker2Opened = !$scope.viewModel.datepicker2Opened;
        };
        $scope.getProviders = function () {
            jobService.selectedProviderId = jobService.selectedProviderId || jobService.defaultProvider.providerId;
            $scope.viewModel.loadingIndicator = true;
            storeDowngraded.dispatch(PreviewEditTemplateActions.getProviders({ userId: $scope.currentUser.userId }));
            var subscribed = previewEditSelectorDowngraded.selectGetProviders().subscribe(function (providers) {
                if (providers) {
                    $log.debug("Got providers from server: " + providers);
                    jobService.providers = angular.copy(providers);
                    console.log("jobService.providers", jobService.providers);
                    $scope.viewModel.loadingIndicator = false;
                }
            });
        };
        $scope.getProviderById = function (providerId) {
            if (jobService.providers !== undefined && providerId !== undefined) {
                for (var i = 0; i < jobService.providers.length; ++i) {
                    if (jobService.providers[i].providerId === providerId) {
                        return jobService.providers[i].providerName;
                    }
                }
            }
            return "Any provider";
        };
        $scope.getProviderLabel = function (provider) {
            return provider.providerName + "(" + provider.remoteProviderId + ")";
        };
        $scope.getReasons = function () {
            $scope.jobService.selectedReasonId =
                $scope.jobService.selectedReasonId || jobService.defaultReason.reasonId;
            storeDowngraded.dispatch(ReasonsSettingsActions.getRemindersReasons({ userId: $scope.currentUser.userId }));
            var subscribed2 = reasonsSettingsSelectorsDowngraded.selectReasons().subscribe(function (reasons) {
                if (reasons) {
                    $log.debug("Got reasons from server: ");
                    jobService.reasons = angular.copy(reasons);
                }
            });
        };
        $scope.getItemTypes = function () {
            storeDowngraded.dispatch(TrackableItemsActions.getItemTypes({ userId: $scope.currentUser.userId }));
            var subscribed3 = trackableItemSelectorDowngraded.selectItemTypes().subscribe(function (itemTypes) {
                if (itemTypes) {
                    $log.debug("Got reasons from server: ");
                    jobService.itemTypes = angular.copy(itemTypes);
                }
            });
        };
        $scope.getStates = function () {
            storeDowngraded.dispatch(TrackableItemsActions.getStates({ userId: $scope.currentUser.userId }));
            var subscribed4 = trackableItemSelectorDowngraded.selectStates().subscribe(function (states) {
                if (states) {
                    $log.debug("Got reasons from server: ");
                    jobService.states = angular.copy(states);
                }
            });
        };
        $scope.getLocationTypes = function () {
            storeDowngraded.dispatch(TrackableItemsActions.getLocationTypes({ userId: $scope.currentUser.userId }));
            var subscribed5 = trackableItemSelectorDowngraded.selectLocationTypes().subscribe(function (locationTypes) {
                if (locationTypes) {
                    $log.debug("Got reasons from server: ");
                    jobService.locationTypes = angular.copy(locationTypes);
                }
            });
        };
        $scope.getLocations = function () {
            storeDowngraded.dispatch(TrackableItemsActions.getLocations({ userId: $scope.currentUser.userId }));
            var subscribed6 = trackableItemSelectorDowngraded.selectLocations().subscribe(function (locations) {
                if (locations) {
                    $log.debug("Got reasons from server: ");
                    jobService.locations = angular.copy(locations);
                }
            });
        };
        $scope.getItemCategory = function () {
            storeDowngraded.dispatch(TrackableItemsActions.getItemCategory({ userId: $scope.currentUser.userId }));
            var subscribed7 = trackableItemSelectorDowngraded.selectItemCategory().subscribe(function (itemCategories) {
                if (itemCategories) {
                    $log.debug("Got reasons from server: ");
                    jobService.itemCategories = angular.copy(itemCategories);
                    $scope.currentItemCategory = angular.copy(itemCategories);
                }
            });
        };
        $scope.getAppointmentStates = function () {
            $scope.viewModel.loadingIndicator = true;
            appointmentServiceDowngraded
                .getAppointmentState($scope.currentUser.userId)
                .subscribe(function (appointmentStates) {
                if (appointmentStates) {
                    $log.debug("Got appointment states from server: " + appointmentStates);
                    jobService.appointmentStates = angular.copy(appointmentStates);
                    $scope.viewModel.loadingIndicator = false;
                }
            });
        };
        $scope.communicationsCategoryName = function (communicationsCategoryId) {
            for (var i in jobService.categories) {
                if (communicationsCategoryId === jobService.categories[i].communicationsCategoryId) {
                    return $filter("i18n")("_communicationsCategory_" + communicationsCategoryId + "_");
                }
            }
            return communicationsCategoryId;
        };
        $scope.getCommunicationsCategory = function (communicationsCategoryId) {
            for (var i in jobService.categories) {
                if (communicationsCategoryId === jobService.categories[i].communicationsCategoryId) {
                    return jobService.categories[i];
                }
            }
        };
        $scope.activeAutomatedJob = function (job) {
            return jobService.activeAutomatedJob(job);
        };
        // TODO: Move into service?
        $scope.chart = {};
        $scope.updateChart = function () {
            $scope.chart = {
                type: "PieChart",
                displayed: true,
                cssStyle: "height:200px; width:400px; margin-bottom: 0px",
                data: [
                    ["Type", "Destinators"],
                    ["Voice", $scope.job.targetStats.voiceAble],
                    ["Text", $scope.job.targetStats.smsAble],
                    ["Email", $scope.job.targetStats.emailAble],
                    ["None", $scope.job.targetStats.noneAble],
                ],
                options: {
                    chartArea: { left: 20, top: 20, width: "100%", height: "100%" },
                    displayExactValues: true,
                    colors: ["#3B80A4", "#4D9EC9", "#6EB3D4", "#92C6E0", "#B7DBEA"],
                    is3D: "false",
                },
            };
        };
        $scope.browserOpen = false;
        $scope.openJob = function (jobId) {
            if (jobService.job.edited) {
                var dialog = dialogs.confirm("Confirm", "Unsaved changes will be lost! Are you sure you want to open another message without saving first?");
                dialog.result.then(function (button) {
                    // Yes
                    $scope.confirmedOpenJob(jobId);
                }, function (button) {
                    // No
                    event.preventDefault();
                    return;
                });
            }
            else {
                $scope.confirmedOpenJob(jobId);
            }
        };
        $scope.confirmedOpenJob = function (jobId) {
            if (jobId !== undefined) {
                $log.info("Opening selected job : " + jobId);
                jobService.job.statsInProgress = false;
                $scope.templateFileRef = ""; // setting it to blank as in case of job we dont have any way to know the fileref
                jobService.job.getJob(jobId).then(function (response) {
                    var templateDefaultContent = {};
                    Object.entries(response.job.jobContent.template).forEach(function (tData) {
                        var updatedTemplateDefault = jobService.templateContextFormat(tData[1], "db");
                        templateDefaultContent[tData[0]] = updatedTemplateDefault.value;
                    });
                    jobService.templateUpdateModel = {
                        updatedModel: templateDefaultContent,
                        isModelUpdated: false,
                        updateType: "updatedJob",
                    };
                    jobService.template = Object.assign(Object.assign({}, jobService.template), { ["templateId"]: response.job.jobContent.media[0].templateId });
                    $scope.browserOpen = false;
                    $scope.templateId = jobService.template.templateId;
                    $scope.saveTargetAndTriggerSettingIfTriggerCategory(response);
                    // $scope.job.updateTargetStats(); // TODO: Consider using a watch inside service that will do this?
                    $scope.refreshTemplateValues();
                });
            }
        };
        $scope.updateTargetStats = function () {
            $scope.job.updateTargetStats();
        };
        $scope.saveTargetAndTriggerSettingIfTriggerCategory = function (response) {
            if (response.job.jobCategory === "triggered") {
                $scope.triggerJob.targets = [...response.job.jobContent.targets];
                $scope.triggerJob.triggerSetting = Object.assign({}, response.job.jobContent.triggerSetting);
                if (Boolean(response.job.jobContent.targets[0].trackableItemCategoryId)) {
                    $scope.triggerJob.trackableItemCategoryId =
                        response.job.jobContent.targets[0].trackableItemCategoryId;
                    $scope.selectedTriggeredMessageType = $scope.ORDERS;
                }
                else {
                    $scope.triggerJob.trackableItemCategoryId = null;
                    $scope.selectedTriggeredMessageType = $scope.APPOINTMENT;
                }
            }
        };
        //         if (jobData.jobState == "draft")
        $scope.viewReport = function () {
            if (jobService.job.edited) {
                var dialog = dialogs.confirm("Confirm", "Unsaved changes will be lost! Are you sure you want view report without saving first?");
                dialog.result.then(function (button) {
                    // Yes
                    $scope.confirmedViewReport();
                }, function (button) {
                    // No
                    event.preventDefault();
                    return;
                });
            }
            else {
                $scope.confirmedViewReport();
            }
        };
        $scope.confirmedViewReport = function () {
            var jobId = jobService.job.jobId;
            if (jobId !== undefined) {
                $log.info("View report for: " + jobId);
                var reportType = "messaging";
                var search = {
                    jobid: jobId,
                };
                if (jobService.job.data.jobCategory === "recalls" || jobService.job.data.jobCategory === "missed") {
                    reportType = jobService.job.data.jobCategory;
                }
                else {
                    search.type = jobService.job.data.jobCategory;
                }
                $location.path("/reports/" + reportType).search(search);
            }
        };
        $scope.disableJob = function (jobId) {
            var dialog = dialogs.confirm("Confirm", "Are you sure you wish to disable automating this message?");
            dialog.result.then(function (button) {
                // Yes
                if (jobId !== undefined) {
                    $log.info("Disabling selected job : " + jobId);
                    jobService.disableJob(jobId).then(function (result) {
                        $log.info("Category '" +
                            jobService.selectedCategoryId +
                            "' has " +
                            jobService.selectedCategory.automatedJobs +
                            " automated jobs");
                    });
                    /*.then(function() {
                            // TODO: Remove from job list
                            });*/
                }
            }, function (button) {
                // No
                event.preventDefault();
            });
        };
        $scope.pauseResumeJob = function (job) {
            var currentState = angular.copy(job.jobState);
            var state = "queued";
            if (job.jobState === "queued") {
                state = "paused";
            }
            job.jobState = state;
            job.isLoading = true;
            jobService
                .pauseResumeJob(job.jobId, state)
                .then(function () {
                // Reload list of templates to update auto banners
                $scope.updateAutomatedCounts();
            })
                .then(function () {
                job.isLoading = false;
                return jobService.loadJobs();
            })
                .then(function (jobs) {
                Array.prototype.slice.call(jobs);
                jobs = $filter("filter")(jobs, function (job) {
                    return job.jobState === "queued";
                });
                jobService.selectedCategory.automatedJobs = jobs.length;
            })
                .catch(function (error) {
                console.log("ERROR of start/pause job. ", error);
                job.jobState = currentState;
                job.isLoading = true;
            });
        };
        $scope.openReport = function (jobId, communicationCategory) {
            if (communicationCategory === "recalls") {
                $location.path("/reports/recalls").search({ jobid: jobId });
            }
            else if (communicationCategory === "missed") {
                $location.path("/reports/missed").search({ jobid: jobId });
            }
            else {
                $location.path("/reports/messaging").search({ type: communicationCategory, jobid: jobId });
            }
        };
        $scope.openJobBrowser = function () {
            $log.info("In autoremind.communications.ScreenController.openJobBrowser() ");
            $scope.browserOpen = true;
            console.log("browser", { communicationsCategory: jobService.selectedCategory, jobs: jobService.jobs });
            var dialog = dialogs.create("app/communication/communications.select.job.html", "autoremind.communications.BrowseJobController", {
                communicationsCategory: jobService.selectedCategory,
                jobs: jobService.jobs,
                usedInCommunication: true,
            }, //TODO: let dialog just use service? or give category and list only?
            { key: false, back: "static" });
            dialog.result.then(function (jobId) {
                $scope.browserOpen = false;
                $log.debug("Opening job " + jobId);
                $scope.openJob(jobId);
                /*
                           if (jobService.job.edited) {
                           var answer = confirm("Unsaved changes will be lost! Are you sure you want to open another message without saving first?");
                           if (!answer) {
                           event.preventDefault();
                           return;
                           };
                           }

                           if (jobId !== undefined) {
                           $log.info('In autoremind.communications.CategoryController.openJobBrowser selected job : ' + jobId);
                           jobService.job.getJob(jobId)
                           .then(function() {
                           $scope.job.updateTargetStats(); // TODO: Consider using a watch inside service that will do this?
                           });
                           }
                           */
            }, function () {
                $scope.browserOpen = false;
            });
        };
        $scope.$watch("jobService.job.targetStats", function (newVal, oldVal) {
            // This is invoked even before adding properties - only update when actual stats are set
            if (newVal !== undefined && !angular.equals({}, newVal)) {
                $scope.updateChart();
            }
        });
        /** NOT IN USE ANYMORE!!!
         * NOTE: This MUST be declared BEFORE initializing job below
         */
        $scope.selectTemplate = function (templateId, templateFile) {
            var oldTemplateId = $scope.viewModel.templateId;
            if (oldTemplateId !== templateId) {
                for (var i in $scope.templates.list) {
                    const template = $scope.templates.list[i];
                    //if (templateId > 0) {
                    if (templateId === template.templateId) {
                        $scope.viewModel.templateId = template.templateId;
                        $scope.viewModel.templateUrl = template.templateUrl;
                        if (!angular.isDefined(oldTemplateId)) {
                            $scope.viewModel.template = template.templateDefaultContent;
                        }
                        break;
                    }
                }
            }
        };
        /**
         * Used by view to display only test destinators for media types included in the job.
         * Currently use is disabled in view
         * TODO: Change to use jobMediaTypes array
         */
        $scope.jobMediaTypeContains = function (mediaType) {
            console.log("jobMediaTypeContains", viewModel.jobMediaType, mediaType);
            if ($scope.viewModel.jobMediaType === undefined) {
                return false;
            }
            else {
                var startIndex = $scope.viewModel.jobMediaType.indexOf(mediaType);
                if (startIndex >= 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
        };
        $scope.openTemplateBrowser = function (type) {
            $log.info("In autoremind.communications.ScreenController.openTemplateBrowser()", $scope.template);
            var cat = $scope.getCommunicationsCategory($scope.viewModel.categoryId);
            cat = jobService.selectedCategory;
            // TODO: Filter templates by type?
            $scope.browserOpen = true;
            var dialog = dialogs.create("app/communication/communications.select.template.html", "autoremind.communications.TemplateBrowserController", 
            //{ templates: $scope.templates.list, communicationsCategory: $scope.getCommunicationsCategory($scope.viewModel.categoryId)},
            { templates: $scope.templates.list, communicationsCategory: cat, templatesType: type }, { key: false, back: "static" });
            dialog.result.then(function (selection) {
                $scope.browserOpen = false;
                var template = selection.template;
                var mediaType = selection.mediaType;
                $log.info("In autoremind.communications.ScreenController.openTemplateBrowser() templateId: " +
                    template.templateId);
                console.log("##template.emailTitle=" + $scope.template.emailTitle);
                $scope.template = Object.assign(Object.assign({}, jobService.template), { ["templateId"]: selection.template.templateId });
                $scope.job.setTemplates(template, mediaType, $scope.templateUpdateModel);
            }, function () {
                $scope.browserOpen = false;
            });
        };
        $scope.send = function () {
            console.log("isAutomatedCategory", $scope.job.isAutomatedCategory);
            if (jobService.job.targetStats.totalAble === 0 && !$scope.job.isAutomatedCategory) {
                dialogs.notify("Note", "It seems no recepients match your target settings. Please adjust the settings.");
                return;
            }
            if (!$scope.isValidTrackableItemJob()) {
                return;
            }
            if (jobService.job.data.jobName === "") {
                dialogs.notify("Note", "You must give the message a name");
                return;
            }
            if ((jobService.job.data.jobCategory === "survey" || jobService.job.data.jobCategory === "reviews") &&
                (jobService.job.maxMessagesDaysBack === "" ||
                    isNaN(jobService.job.maxMessagesDaysBack) ||
                    !(jobService.job.maxMessagesDaysBack > 0))) {
                dialogs.notify("Note", "You must specify the number of days (for max. surveys)");
                return;
            }
            if (jobService.job.targetStats.totalAble === 0 && jobService.job.isAutomatedCategory) {
                var confirmDialog = dialogs.confirm("Confirm", "It seems no recipients match your target settings at the moment, though it may change over time when this automated message. Are you sure you want to automate now or cancel and change the settings?");
                confirmDialog.result.then(function (button) {
                    $scope.applySend();
                });
            }
            else {
                $scope.applySend();
            }
        };
        $scope.applySend = function () {
            $scope.browserOpen = true;
            var dialog = dialogs.create("app/communication/communications.settings.confirm.html", "autoremind.communications.SettingsConfirmController", { sendType: "job", targetStats: jobService.job.targetStats, smsParts: $scope.viewModel.smsParts }, { key: false, back: "static" });
            dialog.result.then(function (isConfirmed) {
                console.log(">>>> SETTING CONFIRM RESULT CALLED <<<<<");
                $scope.browserOpen = false;
                if (isConfirmed !== undefined) {
                    $scope.job.jobConfirm = isConfirmed;
                    //$scope.job.editable = false;
                    // TODO: Review this to get User Company name
                    $scope.job.data.jobContent.accountName = accountService.currentUser.userCompany;
                    $scope.job.data.jobContent.testDestinatorEmail = $scope.viewModel.destinatorEmail || '';
                    $scope.job.data.jobContent.testDestinatorSms =
                        $scope.viewModel.destinatorSms === undefined ? '' : '' + $scope.viewModel.destinatorSms;
                    $scope.job.data.jobContent.testDestinatorVoice =
                        $scope.viewModel.destinatorVoice === undefined ? '' : '' + $scope.viewModel.destinatorVoice;
                    $scope.job.data.jobState = 'queued';
                    if ($scope.job.isAutomatedCategory) {
                        $scope.job.editable = true;
                    }
                    else {
                        $scope.job.editable = false;
                    }
                    var cloneTemplateUpdateModel = {
                        updatedModel: $scope.templateUpdateModel.updatedModel,
                        isModelUpdated: false,
                        updateType: 'savedJob'
                    };
                    jobService.templateUpdateModel = cloneTemplateUpdateModel;
                    jobService.template = angular.copy($scope.templateUpdateModel.updatedModel);
                    $scope.job.save().then(function () { }, function () {
                        // Saving failed (e.g. no name) so revert to draft state so it can be edited again
                        $scope.job.data.jobState = 'draft'; // TODO: This is never reached
                    });
                }
            }, function () {
                $scope.browserOpen = false;
            });
        };
        $scope.sendTest = function () {
            $log.info('In autoremind.communications.ScreenController sendTest()');
            $scope.browserOpen = true;
            $scope.viewModel.testMedia = templateService.activeTabOfMessages;
            // Checking if the template contains correct model and showing an alert to save so we can auto correct it
            var canSendTest = eventSharingService.validateTemplateOnSendTest($scope.templateUpdateModel.updatedModel);
            if (canSendTest) {
                // TODO: dont let them send if the template needs to be saved first
                var dialog = dialogs.create("app/communication/communications.settings.confirm.html", "autoremind.communications.SettingsConfirmController", {
                    sendType: "test",
                    targetStats: jobService.job.targetStats,
                    testMedia: $scope.viewModel.testMedia,
                }, { key: false, back: "static" });
                dialog.result.then(function (isConfirmed) {
                    $scope.browserOpen = false;
                    if (isConfirmed) {
                        //$scope.job.data.jobState = "test"; // NOTE: This job is NOT saved so this state is only temporary
                        $scope.job.data.testMedia = $scope.viewModel.testMedia; // TODO: Use this to determine if it's a test
                        $scope.job.data.jobContent.accountName = userProfile.profileModel.company;
                        var destinator = $scope.viewModel.testMedia === "email"
                            ? $scope.viewModel.destinatorEmail
                            : $scope.viewModel.testMedia === "sms"
                                ? $scope.viewModel.destinatorSms
                                : $scope.viewModel.destinatorVoice;
                        destinator = destinator.replace("+", "");
                        var deviceId = "";
                        for (var i = 0; i < $scope.job.data.jobContent.media.length; i++) {
                            var media = $scope.job.data.jobContent.media[i];
                            if ($scope.viewModel.testMedia === media.type) {
                                deviceId = media.device;
                                break;
                            }
                        }
                        var context = {};
                        context.template = $scope.templateUpdateModel.updatedModel;
                        if (context.template.voiceMessage !== undefined && context.template.voiceMessage === 'Insert Text Here') {
                            context.template.voiceMessage = '';
                        }
                        var datacopy = Object.assign({}, context.template);
                        var templateContent = jobService.job.sanitizeTemplate(datacopy);
                        templateContent = JSON.stringify(templateContent);
                        if (templateContent.indexOf("appointment") !== -1) {
                            context.appointments = [
                                {
                                    firstName: "John",
                                    lastName: "Doe",
                                    appointmentTime: "2021-07-01T02:31",
                                },
                            ];
                            if (templateContent.indexOf("pet.") !== -1) {
                                context.appointments[0].petName = "Pet Name";
                            }
                            var rules = $scope.currentUser.userCustomFields.rules;
                            if (rules !== undefined) {
                                for (var i = 0; i < rules.length; i++) {
                                    var rule = rules[i];
                                    if (context.appointments[0][rule.reference] === undefined && rule.map.length > 0) {
                                        var key = Object.keys(rule.map[0])[0];
                                        // console.log(rule.map[0][key]);
                                        context.appointments[0][rule.reference] =
                                            rule.default !== undefined || rule.default !== ""
                                                ? rule.default
                                                : rule.map[0][key];
                                    }
                                }
                            }
                        }
                        else {
                            context.person = { firstName: "John", lastName: "Doe" };
                            if (templateContent.indexOf("pet.") !== -1) {
                                context.person.petName = "Pet Name";
                            }
                        }
                        if ($scope.selectedTriggeredMessageType === $scope.ORDERS) {
                            context.trackableItem = {};
                            context.trackableItem.trackableItemLocation = jobService.locations[0];
                            context.trackableItem.trackableItemRemoteItemType = jobService.itemTypes[0];
                            context.trackableItem.trackableItemRemoteItemId = "";
                        }
                        var contentType = "relation:" + $scope.jobService.selectedCategoryId;
                        //$scope.job.data.jobContent.account.accountName = userProfile.profileModel.company;
                        storeDowngraded.dispatch(JobActions.sendTestMessage({
                            userId: $scope.currentUser.userId,
                            userName: $scope.currentUser.userName,
                            destinator,
                            mediaType: $scope.viewModel.testMedia,
                            contentType,
                            templateFileRef: $scope.viewModel.selectedTemplate.templateFileRef,
                            templateId: $scope.viewModel.selectedTemplate.templateId,
                            deviceId,
                            context,
                        }));
                    }
                }, function () {
                    $scope.browserOpen = false;
                });
            }
        };
        //$scope.template.voiceMessage = "This is a message for you!";
        $scope.sequences = [];
        /*
                $scope.openFeatureDialog = function() {
                $log.info('In autoremind.communications.ScreenController.openFeatureDialog() ');

                var dialog = dialogs.create('app/communication/communications.feature-dialog.html', 'autoremind.communications.FeatureDialogController',
                { communicationsCategory: jobService.selectedCategory, jobs: jobService.jobs },
                { key: false, back: 'static'} );
                dialog.result
                .then(function(jobId) {
                // Confirm
                }, function() {
                // Cancel
                });
                };
                */
        $scope.openDialog = function (videoidd) {
            // logger.debug('videoidd=' + videoidd);
            dialogs.create("/dialogs/videodialog.html", "videoDialogController", { videoId: videoidd }, {
                key: false,
                back: "static",
            });
        };
        /*
         * get updated phone value
         */
        $scope.viewModel.onSMSNumberChanged = function (event) {
            $scope.viewModel.destinatorSms = event;
        };
        $scope.viewModel.onVoiceNumberChanged = function (event) {
            $scope.viewModel.destinatorVoice = event;
        };
        $scope.showSection = function (selection, itemCategory) {
            $scope.selectedTriggeredMessageType = selection;
            if (Boolean(itemCategory)) {
                $scope.currentItemCategory = itemCategory;
            }
        };
        $scope.isTriggerTypeSelected = function (selection) {
            return $scope.selectedTriggeredMessageType === selection;
        };
        $scope.isValidTrackableItemJob = function () {
            if (jobService.job.data.jobCategory === "triggered" &&
                $scope.selectedTriggeredMessageType === $scope.ORDERS) {
                const remoteItemTypes = jobService.job.jobContent.targets[0]["remoteItemTypes"];
                const remoteItemStates = jobService.job.jobContent.targets[0]["remoteItemStates"];
                let showDialog = false;
                let message = "";
                if (!Boolean(remoteItemTypes) || (Boolean(remoteItemTypes) && remoteItemTypes.length === 0)) {
                    showDialog = true;
                    message = `You must specify Item TYPE.`;
                }
                if (!Boolean(remoteItemStates) || (Boolean(remoteItemStates) && remoteItemStates.length === 0)) {
                    showDialog = true;
                    message = Boolean(message)
                        ? `${message} 
                                                          You must specify Item STATE.`
                        : "You must specify Item STATE.";
                }
                if (showDialog) {
                    dialogs.notify("Note", message);
                    return false;
                }
            }
            return true;
        };
    },
]);
// ----------------------------------------------------------------------
angular.module("autoremind.communications").controller("autoremind.communications.CategoryController", 
// Setup dependencies
[
    "$scope",
    "$log",
    "$interval",
    "userProfile",
    "jobService",
    function ($scope, $log, $interval, userProfile, jobService) {
        $log.info("In autoremind.communications.CategoryController");
        // Map shared model to scope for local reference
        $scope.viewModel = userProfile.viewModel.views.communications;
        // Add categories to visible list one by one with a delay to allow for animation effect to work
        var stopHandler = undefined;
        $scope.update = function () {
            $log.debug("CategoryController: update");
            // Don't start a new update if we are already updating
            if (angular.isDefined(stopHandler))
                return;
            $log.debug("CategoryController: update first time (length=" + jobService.categories.length + ")");
            stopHandler = $interval(function () {
                if ($scope.viewModel.categoryVisibleList.length < jobService.categories.length) {
                    //console.log('jobService.categories', jobService.categories[$scope.viewModel.categoryVisibleList.length]);
                    $scope.viewModel.categoryVisibleList.push(jobService.categories[$scope.viewModel.categoryVisibleList.length]);
                }
                else {
                    if (angular.isDefined(jobService.template.loaded)) {
                        $log.debug("CategoryController: stopping update (length=" + jobService.categories.length + ")");
                        // Only stop service if loading templates was done/attempted and still list is empty
                        $interval.cancel(stopHandler);
                    }
                }
            }, 250);
        };
        $scope.update();
        /*
                $scope.$on('event:profile-and-templates-loaded', function() {
                $scope.update();
                });
                */
    },
]);
// -------------------------------------------------------------------------------------------
// Controller for job select dialog
angular.module("autoremind.communications").controller("autoremind.communications.BrowseJobController", 
// Setup dependencies
[
    "$scope",
    "$log",
    "$uibModalInstance",
    "$filter",
    "data",
    "jobService",
    "dialogs",
    function ($scope, $log, $uibModalInstance, $filter, data, jobService, dialogs) {
        $log.debug("BrowseJobController");
        $scope.dialog = $uibModalInstance;
        $scope.jobService = jobService;
        $scope.jobs = jobService.jobs;
        $scope.job = jobService.job;
        if (!angular.isDefined($scope.viewModel)) {
            $scope.viewModel = {};
        }
        $scope.viewModel.data = angular.isDefined(data) ? data : "";
        $scope.viewModel.communicationsCategory = data.communicationsCategory;
        $scope.viewModel.jobs = data.jobs;
        $scope.viewModel.usedInCommunication = data.usedInCommunication;
        $scope.includeAutomated = false;
        var communicationsCategoryId = null;
        if (data.communicationsCategory !== undefined &&
            data.communicationsCategory !== null &&
            data.communicationsCategory.communicationsCategoryId) {
            $log.info("In autoremind.communications.BrowseJobController for categoryId=" +
                data.communicationsCategory.communicationsCategoryId);
            communicationsCategoryId = data.communicationsCategory.communicationsCategoryId;
            $scope.dialogHeader =
                "Select saved " + $filter("i18n")("_communicationsCategory_" + communicationsCategoryId + "_");
            $scope.includeAutomated = true;
        }
        else {
            $scope.dialogHeader = 'Select Message'; // Used from the Reports page
        }
        jobService.resetList();
        jobService.jobs.getJobs(communicationsCategoryId).then(function () {
            $log.debug('Jobs loaded ' + $scope.jobs.list.length);
            if ($scope.jobs.list.length === 0) {
                // debugger;
            }
        }, function (reason) {
            $uibModalInstance.dismiss();
            dialogs.error('Error', 'There was a problem getting data from the server. Please try again.');
        });
        $scope.deleteJob = function (jobId) {
            var dialog = dialogs.confirm('Confirm', 'Are you sure you wish to delete the message? The Messaging Report for this message will no longer be available.');
            dialog.result.then(function (button) {
                // Yes
                if (jobId !== undefined) {
                    $log.info('Deleting selected job : ' + jobId);
                    jobService.deleteJob(jobId);
                    /*.then(function() {
                            // TODO: Remove from job list
                            });*/
                }
            }, function (button) {
                // No
                event.preventDefault();
            });
        };
        $scope.showMessageDetails = function (jobId) {
            jobService.showMessageDetails(jobId);
        };
        /**
         * Filter out deleted jobs. If not in the Communication page filter out drafts (since they are only relevant when editing)
         * @param {type} job
         * @returns {Boolean}
         */
        $scope.filterByJobState = function (job) {
            return !(job.jobState === 'deleted' ||
                (job.jobState.toLowerCase() === 'draft' && !$scope.viewModel.usedInCommunication));
            // return $scope.includeAutomated || jobService.isAutomatedCategory(job.jobCategory);
        };
        $scope.jobStatusLabel = function (state) {
            return jobService.jobStatusLabel(state);
        };
    },
]);
//-------------------------------------------------------------------------------------------
// controller for select template dialog
angular.module("autoremind.communications").controller("autoremind.communications.TemplateBrowserController", 
// Setup dependencies
[
    '$scope',
    '$log',
    'jobService',
    '$uibModalInstance',
    'data',
    'dialogs',
    'templateService',
    function ($scope, $log, jobService, $uibModalInstance, data, dialogs, templateService) {
        $scope.dialog = $uibModalInstance;
        if (!angular.isDefined($scope.viewModel)) {
            $scope.viewModel = {};
        }
        $scope.viewModel.data = angular.isDefined(data) ? data : "";
        //$scope.viewModel.templates = data.templates;
        $scope.viewModel.templatesType = data.templatesType;
        $scope.jobService = jobService;
        $scope.viewModel.communicationsCategory = data.communicationsCategory;
        $scope.viewModel.selectedTemplate = null;
        $log.info('In autoremind.communications.TemplateBrowserController ' +
            $scope.viewModel.communicationsCategory.communicationsCategoryId);
        // TODO: move to template browser? or do we need the list when selecting first template for selected job?
        jobService.templates.getTemplates().then(function (templates) {
            //$scope.viewModel.templates = jobService.templates.list;
            //$scope.viewModel.templates = templates;
            //$log.debug('templates list length: ' + data.templates.list.length);
        }, function () {
            $uibModalInstance.dismiss();
            dialogs.error('Server problem', 'There was a problem getting the template list from the server.');
        });
        $scope.select = function (template) {
            $log.info('In autoremind.communications.TemplateBrowserController select ' + template.templateId);
            //$scope.viewModel.selectedTemplate = template;
            //dialog.close($scope.template);
            $uibModalInstance.close({ template: template, mediaType: $scope.viewModel.templatesType });
        };
        $scope.previewTemplate = function (template, $event) {
            $event.stopPropagation();
            templateService.editTemplateModelDialog(template, undefined, true, false);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('Canceled');
        };
        $scope.templateTypeFilter = function (template) {
            if ($scope.viewModel.communicationsCategory.communicationsCategoryId === template.communicationsCategoryId) {
                if (template.mediaTypes !== undefined && template.mediaTypes.media !== undefined) {
                    if ($scope.viewModel.templatesType === 'collection' && template.mediaTypes.media.length > 1) {
                        return true;
                    }
                    for (var i = 0; i < template.mediaTypes.media.length; i++) {
                        var media = template.mediaTypes.media[i];
                        //$log.debug('media.type=' + media.type);
                        if ($scope.viewModel.templatesType === media.type) {
                            //$log.debug('media.type=' + media.type);
                            return true;
                        }
                    }
                }
            }
            return false;
        };
        $scope.customTemplateFilter = function (template) {
            var cloneTemplate = angular.copy(template);
            if (cloneTemplate.templateFileRef.match(/\-?\d+\//)) {
                cloneTemplate.templateImg =
                    '/img/communications/category/' + cloneTemplate.communicationsCategoryId + '.png';
            }
            else {
                cloneTemplate.templateImg =
                    '/img/communications/templatethumb/' + cloneTemplate.templateFileRef + '.jpg';
            }
            return cloneTemplate;
        };
        $scope.enableFilter = function (template) {
            return template.isEnabled ? template : false;
        };
    },
]);
//-------------------------------------------------------------------------------------------
//Controller for job select dialog
angular.module("autoremind.communications").controller("autoremind.communications.FeatureDialogController", 
// Setup dependencies
[
    "$scope",
    "$log",
    "authenticationSelectorsDowngraded",
    "$uibModalInstance",
    "$filter",
    "data",
    function ($scope, $log, $uibModalInstance, $filter, data) {
        $scope.dialog = $uibModalInstance;
        if (!angular.isDefined($scope.viewModel)) {
            $scope.viewModel = {};
        }
        $scope.viewModel.data = angular.isDefined(data) ? data : '';
        $scope.viewModel.communicationsCategory = data.communicationsCategory;
        $scope.subject =
            'Communication Feature: ' +
                $filter('i18n')('_communicationsCategory_' + data.communicationsCategory.communicationsCategoryId + '_');
        $scope.body = 'Dear AutoRemind Sales,\n\nI am interested in purchasing the Communication feature...';
        $scope.mailToSales = function () {
            var link = 'mailto:sales@autoremind.us' + '?subject=' + escape($scope.subject) + '&body=' + escape($scope.body);
            window.location.href = link;
            $scope.dialog.close(undefined);
        };
        //var videoIds = {"educational": "X_am2l_ZsdM", "survey": "9Atbgiyue2E"};
        //var videoId = videoIds[data.communicationsCategory.communicationsCategoryId];
        //$scope.videoUrl = 'https://www.youtube.com/embed/' + videoId;
    },
]);
//-------------------------------------------------------------------------------------------
// controller for confirm dialog to enable job
angular.module("autoremind.communications").controller("autoremind.communications.SettingsConfirmController", 
// Setup dependencies
[
    "$scope",
    "$log",
    "$uibModalInstance",
    "data",
    "$http",
    "jobService",
    "accountService",
    function ($scope, $log, $uibModalInstance, data, $http, jobService, accountService) {
        $log.info("In autoremind.communications.SettingsConfirmController");
        $scope.currentUser = accountService.currentUser;
        //$scope.dialog = $uibModalInstance;
        $scope.jobService = jobService;
        $scope.jobs = jobService.jobs;
        $scope.job = jobService.job;
        if (!angular.isDefined($scope.viewModel)) {
            $scope.viewModel = {};
        }
        //$scope.viewModel.data = (angular.isDefined(data)) ? data : '';
        $scope.targetStats = data.targetStats;
        $scope.isTest = false;
        if (data.sendType === "test") {
            $scope.isTest = true;
            $scope.voiceMessages = data.testMedia === "voice" ? 1 : 0;
            $scope.smsMessages = data.testMedia === "sms" ? 1 : 0;
            $scope.emailMessages = data.testMedia === "email" ? 1 : 0;
        }
        else if (data.targetStats === undefined) {
            $scope.voiceMessages = 0;
            $scope.smsMessages = 0;
            $scope.emailMessages = 1;
        }
        else {
            $scope.voiceMessages = data.targetStats.voiceMessages;
            $scope.smsMessages = data.targetStats.smsAble;
            $scope.emailMessages = data.targetStats.emailAble;
            $scope.totalPeople = data.targetStats.totalPeople;
            $scope.totalAble = data.targetStats.totalAble;
            // set total number of sms parts
            $scope.smsParts = data.smsParts;
        }
        $scope.viewModel.confirmed = false;
        $scope.viewModel.showError = false;
        $scope.user = accountService.currentUser.userName;
        // Get IP address of user
        $http.jsonp("//api.ipify.org?format=jsonp&callback=JSON_CALLBACK").then(function (data) {
            $scope.clientIP = data.ip;
        });
        $scope.startJob = function () {
            if ($scope.viewModel.confirmed === true) {
                // Put confirm details into job before saving
                jobService.job.jobContent.clientIP = $scope.clientIP;
                // TODO: Store username (when we're ready with sub user)
                jobService.job.jobContent.clientIP = $scope.clientIP;
                jobService.job.jobContent.targetStats = jobService.job.targetStats;
                $uibModalInstance.close($scope.viewModel.confirmed);
            }
            else {
                $scope.viewModel.showError = true;
            }
        };
        $scope.closeDialog = function () {
            $uibModalInstance.close();
        };
        $scope.editJob = function () {
            $uibModalInstance.dismiss("Canceled");
        };
    },
]);
//# sourceMappingURL=communications.controllers.js.map